<template>
    <AppOnePageDropdown
        v-model="value"
        :idValue="idValue"
        placeholder="Selecione a descrição de risco..."
        optionLabel="nome"
        :service="$service"
        :itemSize="itemSize"
        :resultWithItems="false"
        :renderValue="(slotProps) => slotProps.value?.riscoDescricaoRisco.descricaoRisco?.nome"
        :renderOption="(slotProps) => slotProps.option?.riscoDescricaoRisco.descricaoRisco?.nome"
    >
    </AppOnePageDropdown>
</template>
<script>
import BaseService from '../../../../../services/BaseService';
export default {
    props: {
        modelValue: {
            type: Object
        },
        itemSize: {
            type: Number,
            default: 20
        },
        idValue: {
            type: Number
        },
        filtrosExtras: {
            type: Object
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            $service: null
        };
    },
    computed: {
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    },
    async created() {
        this.$service = new BaseService(
            `/aplicacao-perigo-descricao-risco/aplicacao-resposta-perigo-id/${this.filtrosExtras.aplicacaoRespostaPerigoId}/aplicacao-resposta-perigo-versao/${this.filtrosExtras.aplicacaoRespostaPerigoVersao}/etapa/${this.filtrosExtras.etapa}`
        );
    }
};
</script>
